require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-chatbots-marketing-strategy-2019.json") })
        }
      }, "path---tapd-in-chatbots-marketing-strategy-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-chatbots-marketing-strategy-2019!./.cache/json/tapd-in-chatbots-marketing-strategy-2019.json
// module id = 819
// module chunks = 231608221292675